import {
  LOGIN_INPUT_USERNAME,
  LOGIN_INPUT_PASSWORD,
  LOGIN_STATUS_WAITING,
  LOGIN_STATUS_PROCESSING,
  LOGIN_STATUS_SUCCESS,
  LOGIN_STATUS_FAILED
} from '../constants/login'
import {
  FOCUS_INPUT,
  UPDATE_INPUT,
  DELETE_INPUT,
  ERROR_INPUT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SET_STATUS,
  FOCUS_KEYBOARD
} from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  status: LOGIN_STATUS_WAITING,
  focusedInput: LOGIN_INPUT_USERNAME,
  keyboardFocused: true,
  focusedRow: 0,
  focusedCol: 0,
  errors: {},
  statusReason: ''
}

INITIAL_STATE[LOGIN_INPUT_USERNAME] = ''
INITIAL_STATE[LOGIN_INPUT_PASSWORD] = ''

INITIAL_STATE.errors[LOGIN_INPUT_USERNAME] = ''
INITIAL_STATE.errors[LOGIN_INPUT_PASSWORD] = ''

const checkoutReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case FOCUS_INPUT:
      return {
        ...state,
        focusedInput: action.payload.focusedInput,
        focusedRow: action.payload.focusedRow,
        focusedCol: action.payload.focusedCol
      }
    case UPDATE_INPUT:
      return {
        ...state,
        [state.focusedInput]: state[state.focusedInput] + action.payload.newKey,
        errors: {
          ...state.errors,
          [state.focusedInput]: ''
        }
      }
    case DELETE_INPUT:
      return {
        ...state,
        [state.focusedInput]: state[state.focusedInput].substr(0, state[state.focusedInput].length - 1),
        errors: {
          ...state.errors,
          [state.focusedInput]: ''
        }
      }
    case ERROR_INPUT:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.input]: action.payload.error
        }
      }
    case SET_STATUS:
      return {
        ...state,
        status: action.payload.status
      }
    case FOCUS_KEYBOARD:
      return {
        ...state,
        keyboardFocused: action.payload.focus
      }
    case LOGIN_REQUEST:
      return {
        ...state,
        status: LOGIN_STATUS_PROCESSING
      }
    case LOGIN_SUCCESS:
      return {
        ...INITIAL_STATE,
        status: LOGIN_STATUS_SUCCESS
      }
    case LOGIN_FAILURE:
      return {
        ...state,
        status: LOGIN_STATUS_FAILED,
        statusReason: action.payload.message
      }
    case LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE
      }
    default:
      return state
  }
}

export default checkoutReducer
